// React and related Imports
import React from 'react';

export const SortingIcon: React.FC<{
  onClick: (fieldId: string) => void;
  fieldId: string;
}> = ({ onClick, fieldId }) => {
  return (
    <svg
      className="ms-2 h-4 w-4"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      onClick={() => onClick(fieldId)}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 15l4 4 4-4M8 9l4-4 4 4"
      />
    </svg>
  );
};
